module.exports = __webpack_public_path__ + "static/media/tournaments-future-active-menu-icon.64289e56.svg";